<template>
    <div class="match-team-game-battle-array">
        <!-- head start -->
        <div class="head">
            <game-summary
                :title="gameInfo.title"
                :time="gameInfo.time"
                :homeTeamName="gameInfo.homeTeamName"
                :homeTeamBadge="gameInfo.homeTeamBadge"
                :awayTeamName="gameInfo.awayTeamName"
                :awayTeamBadge="gameInfo.awayTeamBadge">
            </game-summary>
        </div>
        <!-- head end -->
        <div class="title">
            <div class="team-name">
                <div class="line"></div>
                <div class="name">{{ title }}</div>
            </div>
        </div>
        <div class="content">
            <div class="item flex-center" @click="goMatchTeamGameRoster">
                <div class="label">出场名单</div>
                <div class="value">
                    <span class="detail">查看详情</span>
                    <van-icon name="arrow" class="icon" />
                </div>
            </div>
            <div class="item flex-center" @click="showOfficialsPopup = true">
                <div class="label">到场官员</div>
                <div class="value">
                    <span class="empty" v-if="!isOfficialsConfirmed">未设置</span>
                    <span class="detail" v-else>查看详情</span>
                    <van-icon name="arrow" class="icon" />
                </div>
            </div>
            <div class="item flex-center" @click="goMatchTeamGameClothesColor">
                <div class="label">队服颜色</div>
                <div class="value">
                    <span v-if="clothesColors">{{ clothesColors }}</span>
                    <span v-else class="empty">未设置</span>
                    <van-icon name="arrow" class="icon" />  
                </div>
            </div>
        </div>

        <!-- 到场官员  start -->
        <van-popup v-model="showOfficialsPopup" position="bottom">
            <div class="officials-popup">
                <div class="officials-title">到场球队官员</div>
                <div class="officials-list">
                    <div class="officials-item flex-center" v-for="item in officerList" :key="item.id" @click="item.bePresent == 0 ? item.bePresent = 1 : item.bePresent = 0">
                        <div>{{ item.name }}（{{ item.role }}）</div>
                        <van-icon name="success" class="icon" v-if="item.bePresent == 1" />
                    </div>
                </div>
                <div class="footer-btn">
                    <div class="flex-center" v-if="lockListOnStage == 0">
                        <div class="reset-btn" @click="resetOfficials">重置</div>
                        <div class="confirm-btn" @click="confirmOfficials">提交</div>
                    </div>
                    <div v-else>
                        <FooterBtn btnText="返回" showDisable disableLabel="无法更新" disableValue="比赛已检录，无法更新出场信息" @click="showOfficialsPopup = false" />
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import GameSummary from './game-summary.vue'
import { getPassport } from '@/libs/passport'
import { getGameDetail,getGameTeamOfficerList,updateOfficerBePresentList,getBMGameLockListOnStage } from '@/api/match-team-game'
import { DateUtil } from '@/utils'
import Vue from 'vue';
import { Popup } from 'vant';
import FooterBtn from './footer-btn.vue'
Vue.use(Popup);
export default {
    components: {
        GameSummary,
        FooterBtn
    },
    data() {
        return {
            /* The game info */
            gameInfo: {
                /* The title string */
                title: null,
                /* The time string */
                time: null,
                /* The home team id */
                homeTeamId: null,
                /* The home team name */
                homeTeamName: null,
                /* The home team badge */
                homeTeamBadge: null,
                /* The away team id */
                awayTeamId: null,
                /* The away team name */
                awayTeamName: null,
                /* The away team badge */
                awayTeamBadge: null
            },
            title: null,
            showOfficialsPopup: false,
            officerList: [],
            isOfficialsConfirmed: false,
            clothesColors: null,
            type: null,
            lockListOnStage: 0
        }
    },
    created() {
        // validate the passport and prepair the one
        getPassport().then(res => {
            console.log('getPassport', res)
            if (res) {
                this.queryGameInfo()
                this.queryGameTeamOfficerList()
                this.getBMGameLockListOnStage()
            }
        })
	},
    methods: {
        getBMGameLockListOnStage() {
            const routerParams = this.$route.params
            getBMGameLockListOnStage({gameId: routerParams.gameId}).then(res => {
                if (res) {
                    const { data } = res
                    this.lockListOnStage = data.lockListOnStage
                }
            })
        },
        queryGameInfo() {
            const routerParams = this.$route.params
            const params = {
                gameId: routerParams.gameId,
                eventMode: 0,
                simple: 0
            }
            getGameDetail(params).then(response => {
                console.log("get game detail response", response)
                const data = response.data
                // set the game info data
                let title = data.game.matchName
                if (data.game.gameType) {
                    title += ' | ' + data.game.gameType
                }
                if (data.game.roundDescription) {
                    title += ' | ' + data.game.roundDescription
                }
                this.gameInfo.title = title
                const weekDay = DateUtil.parseDateTime(data.game.beginDate, '{a}')
                console.log('weekDay', weekDay)
                const startTime = DateUtil.parseDateTime(data.game.beginDate, '{y}-{m}-{d} {h}:{i}')
                const endTime = DateUtil.parseDateTime(data.game.endDate, '{h}:{i}')
                this.gameInfo.time = '周' + weekDay + ' ' + startTime + '~' + endTime
                this.gameInfo.homeTeamId = data.game.homeTeamId
                this.gameInfo.homeTeamName = data.game.homeTeamName
                this.gameInfo.homeTeamBadge = data.game.homeTeamBadge
                this.gameInfo.awayTeamId = data.game.awayTeamId
                this.gameInfo.awayTeamName = data.game.awayTeamName
                this.gameInfo.awayTeamBadge = data.game.awayTeamBadge
                if (routerParams.teamId === data.game.homeTeamId) {
                    this.type = 'home'
                    this.title = this.gameInfo.homeTeamName
                    if (data.game.homeClothesColors) {
                        const clothesColors = JSON.parse(data.game.homeClothesColors)
                        this.clothesColors = Object.values(clothesColors.teamColor)
                            .filter(item => item && item.trim()) // 过滤掉空值和空字符串
                            .join('、')
                    }
                } else {
                    this.type = 'away'
                    this.title = this.gameInfo.awayTeamName
                    if (data.game.awayClothesColors) {
                        const clothesColors = JSON.parse(data.game.awayClothesColors)
                        this.clothesColors = Object.values(clothesColors.teamColor)
                            .filter(item => item && item.trim()) // 过滤掉空值和空字符串
                            .join('、')
                    }
                }
            })
        },
        queryGameTeamOfficerList() {
            this.isOfficialsConfirmed = false
            const routerParams = this.$route.params
            const params = {
                gameId: routerParams.gameId,
                teamId: routerParams.teamId,
                matchId: routerParams.matchId
            }
            getGameTeamOfficerList(params).then(response => {
                console.log('getGameTeamOfficerList', response)
                const data = response.data
                this.officerList = data.list.map(item => {
                    if(item.bePresent == 1) {
                        this.isOfficialsConfirmed = true
                    }
                    return {
                        name: item.name,
                        role: item.role,
                        id: item.id,
                        bePresent: item.bePresent
                    }
                })
            })
        },
        resetOfficials() {
            this.officerList.forEach(item => {
                item.bePresent = 0
            })
        },
        confirmOfficials() {
            const routerParams = this.$route.params
            const params = {
                gameId: routerParams.gameId,
                teamId: routerParams.teamId,
                matchId: routerParams.matchId
            }
            const officerIds = this.officerList.filter(item => item.bePresent == 1).map(item => item.id)
            const data = {
                officerIds: officerIds.join(',')
            }
            updateOfficerBePresentList(params,data).then(response => { 
                if (response) {
                    this.queryGameTeamOfficerList()
                    this.$toast('提交成功')
                    this.showOfficialsPopup = false
                }
            })
        },
        goMatchTeamGameRoster() {
            const routerParams = this.$route.params
            this.$router.push({ name: 'MatchTeamGameRoster', params: { ...routerParams }, query: { lockListOnStage: this.lockListOnStage }})
        },
        goMatchTeamGameClothesColor() {
             this.$router.push({ name: 'MatchTeamGameClothesColor', query:{ type: this.type, lockListOnStage: this.lockListOnStage }})
        }
    },
};
</script>

<style scoped lang="scss">
.match-team-game-battle-array{
    .head{
        background-color: #fff;
    }
    .title{
        padding: 20px 16px;
        .team-name{
            position: relative;
            display:inline-block;
            padding: 0 2px;
            .name{
                font-size: 16px;
                font-weight: 500;
                color: #3D3D3D;
            }
            .line{
                position: absolute;
                left: 0;
                bottom: -1px;
                width: 100%;
                height: 6px;
                background-color: #0FAC7F;
                z-index: -1;
            }
        }
    }
    .content{
        padding: 10px;
        .item{
            height: 50px;
            border-radius: 5px;
            border: 1px solid #F8F8F8;
            font-size: 15px;
            padding: 0 14px;
            box-sizing: border-box;
            margin-bottom: 10px;
            .label{
                color: #666666;
            }
            .value{
                color: #0FAC7F;
                span{
                    color: rgba(83, 83, 83, 1);
                }
                .detail{
                    color: #00B578;
                }
                .empty{
                    color: #999999;
                }
                .icon{
                    color: rgba(0, 0, 0, 0.9);
                    margin-left: 4px;
                }
            }
        }
    }
    .officials-popup{
        .officials-title{
            text-align: center;
            height: 54px;
            border-bottom: 1px solid #E5E5E5;
            font-size: 16px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.9);
            line-height: 54px;
        }
        .officials-list{
            height: 220px;
            overflow-y: auto;
            .officials-item{
                padding: 0 16px;
                height: 54px;
                line-height: 54px;
                border-bottom: 1px solid #E5E5E5;
                font-size: 16px;
                color: #1D2129;
                .icon{
                    font-size: 20px;
                    color: #0BAC6D;
                }
            }
        }
        .footer-btn{
            // height: 65px;
            padding-bottom: 33px;
            font-size: 16px;
            font-weight: 500;
            .flex-center{
                height: 47px;
                line-height: 47px;
                padding: 0 16px;
                padding-top: 15px;
                .reset-btn{
                    width: 140px;
                    text-align: center;
                    height: 100%;
                    box-sizing: border-box;
                    border: 1px solid #00B578;
                    color: #00B578;
                    border-radius: 6px;
                    margin-right: 23px;
                }
                .confirm-btn{
                    flex: 1;
                    background: #0FAC7F;
                    color: #FFFFFF;
                    text-align: center;
                    border-radius: 6px;
                }

            }
        }
    }
}
</style>
